import {isNotNil} from 'ramda';

import {PAY_PER_USE_OPERATION_LABEL} from '../constants/PAY_PER_USE_OPERATION_LABEL';
import {getOperationTypeKey} from './getOperationTypeKey';

interface OperationTypeIdentity {
  resource: string;
  action: string;
}

export type OperationTypeLabel =
  | {kind: 'translation'; translationKey: string}
  | {kind: 'raw'; text: string};

/**
 * Resolves the display label for an operation-type pair:
 * 1. FE per-pair label key, else
 * 2. the raw action string (unmapped pairs) — keeps the UI data-driven.
 */
export const getOperationTypeLabel = (operation: OperationTypeIdentity): OperationTypeLabel => {
  const perPairLabelKey = PAY_PER_USE_OPERATION_LABEL[getOperationTypeKey(operation)];

  if (isNotNil(perPairLabelKey)) {
    return {kind: 'translation', translationKey: perPairLabelKey};
  }

  return {kind: 'raw', text: operation.action};
};
